import React from "react";
import { connect } from "react-redux";
import { IAppState } from "../../state/interfaces";
import { FULL_QUOTE_STEPS } from "../../AppConstants";

interface IProps {
    progress: 0
}

class Progress extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    render() {
        return (
            <div className="quote-progress">
                <div className="steps">
                    <div className="row step-names">
                        <div className="col-3 text-center">Cars</div>
                        <div className="col-3 text-center">Drivers</div>
                        <div className="col-3 text-center">Finalize</div>
                        <div className="col-3 text-center">Payment</div>
                    </div>
                    <div className="progress" style={{ height: 4 }}>
                        <div className="progress-bar" role="progressbar" style={{ width: this.props.progress + '%' }}></div>
                    </div>
                </div>
            </div>
        );
    }
}

function calculateProgress(currentStep: string) {
    switch (currentStep) {
        case FULL_QUOTE_STEPS.YOUR_HOME:
            return 5;
        case FULL_QUOTE_STEPS.CARS:
            return 25;
        case FULL_QUOTE_STEPS.DRIVERS:
            return 50;
        case FULL_QUOTE_STEPS.COVERAGES:
        case FULL_QUOTE_STEPS.ADDITIONAL_DRIVERS:
        case FULL_QUOTE_STEPS.POLICY_DETAILS:
        case FULL_QUOTE_STEPS.FINALIZE:
            return 75;
        case FULL_QUOTE_STEPS.OFFLINE:
        case FULL_QUOTE_STEPS.PAYMENT:
        case FULL_QUOTE_STEPS.FINISH:
            return 100;
        default:
            return 5;
    }
}

let mapProps = (state: IAppState) => {
    return {
        progress: calculateProgress(state.currentStep)
    }
}

export default connect(mapProps)(Progress)
